import { CONTRACT_GROUPS } from './contracts'
import contractTranslations from 'translations/contract'
import organizationTranslations from 'translations/organization'
import { ORGANIZATION_ORIGIN_TRANSLATIONS } from 'translations/organizationOrigin'

export const HUBSTAIRS_ID = '5e8c228d1bae80366fd11328'

export const DEMO_ORGANIZATION = '61e6e370a73b437397077203'

export const ORGANIZATION_TRIAL_STATUS = {
  PENDING_ACTIVATION: 'pendingActivation',
  ONGOING: 'ongoing',
  DONE: 'done',
  CONVERTED: 'converted',
}

export const ORGANIZATION_TRIAL_TYPE = {
  SEVEN_DAYS: 'sevenDays',
  SEVEN_DAYS_EXTENDED_TO_THIRTY: 'sevenDaysExtendedToThirty',
  THIRTY_DAYS: 'thirtyDays',
}

export const AI_WATERMARK_POSITION = {
  TOP_LEFT: 'topLeft',
  TOP_RIGHT: 'topRight',
  BOTTOM_LEFT: 'bottomLeft',
  BOTTOM_RIGHT: 'bottomRight',
}

export const AI_WATERMARK_LIMITS = {
  OPACITY_PERCENT: { MIN: 10, MAX: 100 },
  SIZE_PERCENT: { MIN: 1, MAX: 50 },
  MARGIN_PERCENT: { MIN: 0, MAX: 20 },
}

function isTrialRestricted(trial) {
  return Boolean(trial?.status) && trial.status !== ORGANIZATION_TRIAL_STATUS.CONVERTED
}

export function hasReachedTrialAuditLimit(trial) {
  return isTrialRestricted(trial) && trial.launchedAuditsCount >= trial.maxAudits
}

export function isTrialEndpointLocked(trial) {
  return isTrialRestricted(trial) && Boolean(trial.hasDeliveredAudit)
}

export const HUBSTAIRS_PICTURE = {
  fileId: '60908260f15d81e25a0535af',
  url: 'https://res.cloudinary.com/hubstairs/image/upload/v1620083295/production/7eef17f4.png',
  height: 400,
  cloudinary: {
    publicId: 'production/7eef17f4',
    format: 'png',
    version: 1620083295,
  },
  width: 400,
}

export const ORGANIZATION_EXPERIENCE_TABS = {
  ALL: 'all',
  SELF_SERVE_FEATURES: 'selfServeFeatures',
  EXPERIENCE_ON_PLATFORM: 'experienceOnPlatform',
  WORKFLOW_SETTINGS: 'workflowSettings',
  DELIVERY_OPTIONS: 'deliveryOptions',
}

export const MANAGEABLE_ORGANIZATION_EXPERIENCE_PREFERENCES = {
  HAS_NFINITE_PRODUCTS_LISTING: {
    key: 'hasNfiniteProductsListing',
    // To later define which contractTypes can see each preference
    //availableFor: [],
    areasOfImpact: ['Product'],
    tabs: [ORGANIZATION_EXPERIENCE_TABS.ALL, ORGANIZATION_EXPERIENCE_TABS.EXPERIENCE_ON_PLATFORM],
  },
  HAS_GEN_AI_SELF_SERVE_OFFERS: {
    key: 'hasGenAISelfServeOffers',
    // To later define which contractTypes can see each preference
    //availableFor: [],
    areasOfImpact: ['Scene'],
    tabs: [ORGANIZATION_EXPERIENCE_TABS.ALL, ORGANIZATION_EXPERIENCE_TABS.SELF_SERVE_FEATURES],
  },
  HAS_NEW_SCENE_OFFERS: {
    key: 'hasNewSceneOffers',
    // To later define which contractTypes can see each preference
    //availableFor: [],
    areasOfImpact: ['Scene'],
    tabs: [ORGANIZATION_EXPERIENCE_TABS.ALL, ORGANIZATION_EXPERIENCE_TABS.SELF_SERVE_FEATURES],
  },
  INSTANT_LAYER: {
    key: 'instantLayer',
    // To later define which contractTypes can see each preference
    //availableFor: [],
    areasOfImpact: ['Scene'],
    tabs: [ORGANIZATION_EXPERIENCE_TABS.ALL, ORGANIZATION_EXPERIENCE_TABS.EXPERIENCE_ON_PLATFORM],
  },
  PLAIN_RENDERING_MODE: {
    key: 'plainRenderingMode',
    // To later define which contractTypes can see each preference
    //availableFor: [],
    areasOfImpact: ['Scene'],
    tabs: [ORGANIZATION_EXPERIENCE_TABS.ALL, ORGANIZATION_EXPERIENCE_TABS.EXPERIENCE_ON_PLATFORM],
  },
  GENERIC_STAGE_TEMPLATES: {
    key: 'genericStageTemplates',
    // To later define which contractTypes can see each preference
    //availableFor: [],
    areasOfImpact: ['Scene', 'Templates'],
    tabs: [ORGANIZATION_EXPERIENCE_TABS.ALL, ORGANIZATION_EXPERIENCE_TABS.EXPERIENCE_ON_PLATFORM],
  },
  HIDE_AUDIT_AUTOMATICALLY: {
    key: 'hideAuditAutomatically',
    // To later define which contractTypes can see each preference
    //availableFor: [],
    areasOfImpact: ['Workflow'],
    tabs: [ORGANIZATION_EXPERIENCE_TABS.ALL, ORGANIZATION_EXPERIENCE_TABS.EXPERIENCE_ON_PLATFORM],
  },
  SHOW_BENCHMARK_DATA_ON_AUDITS: {
    key: 'showBenchmarkDataOnAudits',
    areasOfImpact: ['Audit'],
    tabs: [ORGANIZATION_EXPERIENCE_TABS.ALL, ORGANIZATION_EXPERIENCE_TABS.EXPERIENCE_ON_PLATFORM],
  },
  HAS_FREESTYLE_PACKSHOT_OFFERS: {
    key: 'hasFreestylePackshotOffers',
    // To later define which contractTypes can see each preference
    //availableFor: [],
    areasOfImpact: ['Packshot'],
    tabs: [ORGANIZATION_EXPERIENCE_TABS.ALL, ORGANIZATION_EXPERIENCE_TABS.SELF_SERVE_FEATURES],
  },
  HAS_ONE_CLICK_OFFERS: {
    key: 'hasOneClickOffers',
    // To later define which contractTypes can see each preference
    //availableFor: [],
    areasOfImpact: ['Packshot'],
    tabs: [ORGANIZATION_EXPERIENCE_TABS.ALL, ORGANIZATION_EXPERIENCE_TABS.SELF_SERVE_FEATURES],
  },
  HAS_FREESTYLE_360_OFFERS: {
    key: 'hasFreestyle360Offers',
    // To later define which contractTypes can see each preference
    //availableFor: [],
    areasOfImpact: ['Video'],
    tabs: [ORGANIZATION_EXPERIENCE_TABS.ALL, ORGANIZATION_EXPERIENCE_TABS.SELF_SERVE_FEATURES],
  },
  SCENES_AS_JPEG: {
    key: 'scenesAsJPEG',
    // To later define which contractTypes can see each preference
    //availableFor: [],
    areasOfImpact: ['OutputFile'],
    tabs: [ORGANIZATION_EXPERIENCE_TABS.ALL, ORGANIZATION_EXPERIENCE_TABS.DELIVERY_OPTIONS],
  },
  VISUAL_LAYERS_DOWNLOAD: {
    key: 'visualLayersDownload',
    // To later define which contractTypes can see each preference
    //availableFor: [],
    areasOfImpact: ['OutputFile'],
    tabs: [ORGANIZATION_EXPERIENCE_TABS.ALL, ORGANIZATION_EXPERIENCE_TABS.DELIVERY_OPTIONS],
  },
  EXPORT_PSD: {
    key: 'exportPSD',
    // To later define which contractTypes can see each preference
    //availableFor: [],
    areasOfImpact: ['OutputFile'],
    tabs: [ORGANIZATION_EXPERIENCE_TABS.ALL, ORGANIZATION_EXPERIENCE_TABS.DELIVERY_OPTIONS],
  },
  EXPORT_EXR: {
    key: 'exportEXR',
    // To later define which contractTypes can see each preference
    //availableFor: [],
    areasOfImpact: ['OutputFile'],
    tabs: [ORGANIZATION_EXPERIENCE_TABS.ALL, ORGANIZATION_EXPERIENCE_TABS.DELIVERY_OPTIONS],
  },
  EXPORT_TIF: {
    key: 'exportTIF',
    // To later define which contractTypes can see each preference
    //availableFor: [],
    areasOfImpact: ['OutputFile'],
    tabs: [ORGANIZATION_EXPERIENCE_TABS.ALL, ORGANIZATION_EXPERIENCE_TABS.DELIVERY_OPTIONS],
  },
  BYPASS_PDP_CUSTOMER_REVIEW: {
    key: 'bypassPDPCustomerReview',
    // To later define which contractTypes can see each preference
    //availableFor: [],
    areasOfImpact: ['Workflow', 'PDP'],
    tabs: [ORGANIZATION_EXPERIENCE_TABS.ALL, ORGANIZATION_EXPERIENCE_TABS.WORKFLOW_SETTINGS],
  },
  DELIVER_VISUALS_VIA_PDP_PACKAGE: {
    key: 'deliverVisualsViaPDPPackage',
    // To later define which contractTypes can see each preference
    //availableFor: [],
    areasOfImpact: ['Workflow', 'PDP'],
    tabs: [ORGANIZATION_EXPERIENCE_TABS.ALL, ORGANIZATION_EXPERIENCE_TABS.WORKFLOW_SETTINGS],
  },
}

export { ORGANIZATION_ORIGIN, ORGANIZATION_ORIGIN_VALUES } from './organizationOrigin'

export const SUGGESTED_RETAILERS_LIMIT = 5

const ORGANIZATION_NAMES_SEPARATOR = ', '
const ORGANIZATION_NAMES_LAST_SEPARATOR = ' & '

export function formatOrganizationNames(names = []) {
  if (names.length <= 1) return names.join('')
  return `${names.slice(0, -1).join(ORGANIZATION_NAMES_SEPARATOR)}${ORGANIZATION_NAMES_LAST_SEPARATOR}${names.at(-1)}`
}

const FULL_ORIGINS_SEPARATOR = '\n'
const FULL_ORIGIN_LINE_PREFIX = '• '
const ORIGIN_NAMES_SEPARATOR = ': '

// [{ origin, suggestedRetailerNames }] for every ticked origin already held by LIMIT other retailers
export function getFullSuggestedRetailerOrigins(origins = [], otherSuggestedRetailers = []) {
  return origins
    .map(origin => ({
      origin,
      suggestedRetailerNames: otherSuggestedRetailers
        .filter(({ suggestedRetailerOrigins }) => suggestedRetailerOrigins?.includes(origin))
        .map(({ name }) => name),
    }))
    .filter(({ suggestedRetailerNames }) => suggestedRetailerNames.length >= SUGGESTED_RETAILERS_LIMIT)
}

export function getSuggestedRetailersLimitMessage(fullOrigins = [], translate) {
  if (!fullOrigins.length) {
    return {
      ...organizationTranslations.errorSuggestedRetailersLimitWithoutDetails,
      values: { limit: SUGGESTED_RETAILERS_LIMIT },
    }
  }
  const details = fullOrigins
    .map(
      ({ origin, suggestedRetailerNames }) =>
        `${FULL_ORIGIN_LINE_PREFIX}${translate(ORGANIZATION_ORIGIN_TRANSLATIONS[origin])}${ORIGIN_NAMES_SEPARATOR}${formatOrganizationNames(suggestedRetailerNames)}`,
    )
    .join(FULL_ORIGINS_SEPARATOR)
  return {
    ...organizationTranslations.errorSuggestedRetailersLimit,
    values: { limit: SUGGESTED_RETAILERS_LIMIT, details: `${FULL_ORIGINS_SEPARATOR}${details}` },
  }
}

export function getTypeLabelFromMainContractGroup(mainContractGroup) {
  switch (mainContractGroup) {
    case CONTRACT_GROUPS.RETAILER:
      return contractTranslations[CONTRACT_GROUPS.RETAILER]
    case CONTRACT_GROUPS.SUPPLIER:
      return contractTranslations[CONTRACT_GROUPS.SUPPLIER]
    case CONTRACT_GROUPS.JOBBER:
      return contractTranslations[CONTRACT_GROUPS.JOBBER]
    default:
      return null
  }
}
